var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.liquidacion.periodo)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',{},[_vm._v(" "+_vm._s(_vm.liquidacion.periodo)+" "+_vm._s(_vm.liquidacion.tipo_liquidacion)+" ")]),_c('hr'),_c('tabla-recibos-admin',{attrs:{"tipo":2,"liquidacion":_vm.liquidacion}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }